(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-cart')) {
    customElements.define(
      'sr-cart',
      class extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.addEventListener('click', (event) => this.onClick(event));
          this.addEventListener('submit', (event) => this.onSubmit(event));
          this.addEventListener('input', (event) => {
            if (event.target.matches('[data-cart-note]')) this.queueNote(event.target.value);
          });
        }

        get codes() {
          return (this.dataset.codes || '')
            .split(',')
            .map((code) => code.trim())
            .filter(Boolean);
        }

        onClick(event) {
          const step = event.target.closest('[data-qty-step]');
          if (step) {
            const line = step.closest('[data-line-key]');
            const next = Number(line.dataset.qty) + Number(step.dataset.qtyStep);
            this.changeLine(line, Math.max(0, next));
            return;
          }
          const remove = event.target.closest('[data-remove]');
          if (remove) {
            this.changeLine(remove.closest('[data-line-key]'), 0);
            return;
          }
          const chip = event.target.closest('[data-discount-remove]');
          if (chip) {
            const code = chip.dataset.discountRemove;
            this.applyCodes(this.codes.filter((c) => c.toLowerCase() !== code.toLowerCase()));
          }
        }

        onSubmit(event) {
          const form = event.target;
          if (form.matches('[data-discount-form]')) {
            event.preventDefault();
            const code = form.elements.discount.value.trim();
            if (!code) return;
            this.applyCodes([...this.codes, code], code);
            return;
          }
          if (form.matches('[data-sr-add]')) {
            event.preventDefault();
            this.addVariant(form);
          }
        }

        async request(url, body) {
          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ...body, sections: [this.sectionId], sections_url: window.location.pathname }),
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            const error = new Error(data.description || data.message || 'Errore');
            error.status = response.status;
            throw error;
          }
          return data;
        }

        async changeLine(line, quantity) {
          if (!line || this.busy) return;
          const max = line.dataset.max !== undefined ? Number(line.dataset.max) : null;
          let notice = '';
          if (max !== null && quantity > max) {
            quantity = max;
            notice = `Disponibili solo ${max} pezzi: abbiamo aggiornato la quantità.`;
          }
          if (quantity === Number(line.dataset.qty) && !notice) return;
          const key = line.dataset.lineKey;
          await this.run(() => this.request('/cart/change.js', { id: key, quantity }), {
            lineKey: key,
            notice,
            status: quantity === 0 ? 'Prodotto rimosso dal carrello.' : 'Carrello aggiornato.',
          });
        }

        async applyCodes(codes, newCode) {
          const unique = [...new Set(codes)];
          await this.run(
            async () => {
              let data = await this.request('/cart/update.js', { discount: unique.join(',') });
              if (newCode) {
                const entry = (data.discount_codes || []).find(
                  (c) => c.code.toLowerCase() === newCode.toLowerCase()
                );
                if (!entry || !entry.applicable) {
                  const rest = unique.filter((c) => c.toLowerCase() !== newCode.toLowerCase());
                  data = await this.request('/cart/update.js', { discount: rest.join(',') });
                  data.__discountError = true;
                }
              }
              return data;
            },
            { status: 'Sconti aggiornati.', keepDiscountOpen: Boolean(newCode), failedCode: newCode }
          );
        }

        async addVariant(form) {
          const id = Number(form.elements.id.value);
          await this.run(
            async () => {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
              }).then((r) => {
                if (!r.ok) throw new Error('add');
              });
              return this.request('/cart/update.js', {});
            },
            { status: 'Prodotto aggiunto al carrello.' }
          );
        }

        queueNote(value) {
          clearTimeout(this.noteTimer);
          this.noteTimer = setTimeout(() => {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: value }),
            }).catch(() => {});
          }, 500);
        }

        async run(task, options = {}) {
          this.busy = true;
          this.setAttribute('aria-busy', 'true');
          const openExtras = [...this.querySelectorAll('details[data-extra][open]')].map((d) => d.dataset.extra);
          try {
            const data = await task();
            this.render(data, openExtras, options);
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: data, source: 'sr-cart' } }));
            this.announce(options.status);
          } catch (error) {
            if (options.lineKey) {
              this.showLineNotice(
                options.lineKey,
                error.status === 422
                  ? 'Quantità non disponibile: ne abbiamo meno in magazzino.'
                  : 'Non è stato possibile aggiornare la quantità. Riprova.'
              );
            } else {
              this.announce('Si è verificato un errore. Riprova.');
            }
          } finally {
            this.busy = false;
            this.removeAttribute('aria-busy');
          }
        }

        render(data, openExtras, options) {
          const html = data && data.sections && data.sections[this.sectionId];
          if (!html) {
            window.location.reload();
            return;
          }
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('sr-cart');
          if (!fresh) return;
          this.dataset.codes = fresh.dataset.codes || '';
          this.innerHTML = fresh.innerHTML;
          openExtras.forEach((name) => {
            const details = this.querySelector(`details[data-extra="${name}"]`);
            if (details) details.open = true;
          });
          if (options.keepDiscountOpen) {
            const details = this.querySelector('details[data-extra="discount"]');
            if (details) details.open = true;
          }
          if (data.__discountError) {
            const form = this.querySelector('[data-discount-form]');
            if (form) {
              form.elements.discount.value = options.failedCode || '';
              form.elements.discount.setAttribute('aria-invalid', 'true');
              form.querySelector('[data-discount-error]').hidden = false;
              form.elements.discount.focus();
            }
          }
          if (options.notice && options.lineKey) this.showLineNotice(options.lineKey, options.notice);
        }

        showLineNotice(key, message) {
          const line = [...this.querySelectorAll('[data-line-key]')].find((el) => el.dataset.lineKey === key);
          if (!line) return;
          const notice = line.querySelector('[data-line-notice]');
          notice.querySelector('[data-line-notice-text]').textContent = message;
          notice.hidden = false;
        }

        announce(message) {
          const status = this.querySelector('[data-cart-status]');
          if (status && message) status.textContent = message;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sr-cookie-prefs]');
    if (!link) return;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    const api = privacy && (privacy.showPreferences || privacy.openPreferences);
    if (typeof api !== 'function') return;
    event.preventDefault();
    api.call(privacy);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-header')) {
    customElements.define(
      'sr-header',
      class extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('[data-sr-drawer]');
          this.scrim = this.querySelector('[data-sr-scrim]');
          this.triggers = [...this.querySelectorAll('[data-sr-menu-trigger]')];
          this.openTrigger = null;
          this.hoverTimer = null;
          this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-sr-drawer-open]')) {
              this.drawer.showModal();
              document.documentElement.classList.add('sr-scroll-lock');
              return;
            }
            if (event.target.closest('[data-sr-drawer-close]')) {
              this.drawer.close();
              return;
            }
            const trigger = event.target.closest('[data-sr-menu-trigger]');
            if (trigger) {
              this.toggle(trigger, trigger !== this.openTrigger);
              return;
            }
            if (event.target === this.drawer) this.drawer.close();
          });

          this.drawer.addEventListener('close', () => document.documentElement.classList.remove('sr-scroll-lock'));

          this.triggers.forEach((trigger) => {
            const item = trigger.closest('[data-sr-menu-item]');
            const panel = document.getElementById(trigger.getAttribute('aria-controls'));
            if (!this.canHover) return;
            [item, panel].forEach((el) => {
              el.addEventListener('mouseenter', () => this.schedule(() => this.toggle(trigger, true), 80));
              el.addEventListener('mouseleave', () => this.schedule(() => this.closeAll(), 160));
            });
          });

          this.scrim.addEventListener('click', () => this.closeAll());
          this.scrim.addEventListener('mouseenter', () => this.schedule(() => this.closeAll(), 160));

          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.openTrigger) {
              const trigger = this.openTrigger;
              this.closeAll();
              trigger.focus();
            }
          });

          document.addEventListener('click', (event) => {
            if (this.openTrigger && !this.contains(event.target)) this.closeAll();
          });

          this.addEventListener('focusout', (event) => {
            if (this.openTrigger && event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll();
          });

          document.addEventListener('cart:update', (event) => this.updateCount(event));
        }

        schedule(fn, delay) {
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(fn, delay);
        }

        toggle(trigger, open) {
          this.triggers.forEach((t) => {
            const isTarget = t === trigger && open;
            t.setAttribute('aria-expanded', String(isTarget));
            const panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !isTarget;
          });
          this.openTrigger = open ? trigger : null;
          this.scrim.hidden = !open;
        }

        closeAll() {
          clearTimeout(this.hoverTimer);
          this.triggers.forEach((t) => {
            t.setAttribute('aria-expanded', 'false');
            const panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = true;
          });
          this.openTrigger = null;
          this.scrim.hidden = true;
        }

        async updateCount(event) {
          const badge = this.querySelector('[data-sr-cart-count]');
          if (!badge) return;
          let count = event && event.detail && event.detail.resource && event.detail.resource.item_count;
          if (typeof count !== 'number') {
            try {
              const cart = await fetch('/cart.js').then((r) => r.json());
              count = cart.item_count;
            } catch (e) {
              return;
            }
          }
          badge.textContent = count;
          badge.hidden = count === 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-lead-dialog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.srLeadDialogReady) return;
    window.srLeadDialogReady = true;

    const getDialog = () => document.querySelector('[data-sr-lead-dialog]');

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-sr-lead-open]');
      if (opener) {
        const dialog = getDialog();
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        dialog.showModal();
        const form = dialog.querySelector('sr-lead-form');
        if (form) form.onOpen();
        return;
      }

      const closer = event.target.closest('[data-sr-lead-close]');
      if (closer) {
        const dialog = closer.closest('[data-sr-lead-dialog]');
        if (dialog) dialog.close();
        return;
      }

      const dialog = event.target.matches && event.target.matches('[data-sr-lead-dialog]') ? event.target : null;
      if (dialog && dialog.open) dialog.close();
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-gallery')) {
    customElements.define(
      'sr-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-sr-slide]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-sr-thumb]'));
          this.thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => this.show(index));
          });
        }

        show(index) {
          this.slides.forEach((slide, i) => {
            slide.hidden = i !== index;
          });
          this.thumbs.forEach((thumb, i) => {
            thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
      }
    );
  }

  (() => {
    if (window.srHeroStickyReady) return;
    window.srHeroStickyReady = true;
    const GAP = 24;
    const update = () => {
      document.querySelectorAll('[data-sr-sticky]').forEach((el) => {
        const top = Math.min(GAP, window.innerHeight - el.offsetHeight - GAP);
        el.style.setProperty('--sr-sticky-top', top + 'px');
      });
    };
    const start = () => {
      update();
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(update);
        document.querySelectorAll('[data-sr-sticky]').forEach((el) => ro.observe(el));
      }
      window.addEventListener('resize', update, { passive: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-sticky-buy')) {
    customElements.define(
      'sr-sticky-buy',
      class extends HTMLElement {
        connectedCallback() {
          this.visibleTargets = new Set();
          const targets = Array.from(
            document.querySelectorAll('[data-sr-buy-anchor], [data-sr-sticky-hide], .shopify-section-group-footer-group')
          );
          if (targets.length === 0 || !('IntersectionObserver' in window)) return;

          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.visibleTargets.add(entry.target);
              } else {
                this.visibleTargets.delete(entry.target);
              }
            });
            const firstAnchor = document.querySelector('[data-sr-buy-anchor]');
            const pastHero = firstAnchor ? firstAnchor.getBoundingClientRect().bottom < 0 : true;
            this.toggle(pastHero && this.visibleTargets.size === 0);
          });
          targets.forEach((target) => this.observer.observe(target));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        toggle(show) {
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
          this.querySelectorAll('a, button').forEach((el) => {
            if (show) {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', '-1');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-carousel')) {
    customElements.define(
      'sr-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-sr-track]');
          this.cards = Array.from(this.querySelectorAll('[data-sr-card]'));
          this.dots = Array.from(this.querySelectorAll('[data-sr-dot]'));
          if (!this.track || this.dots.length === 0) return;
          this.onScroll = this.onScroll.bind(this);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
        }

        disconnectedCallback() {
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        }

        onScroll() {
          const left = this.track.scrollLeft;
          let active = 0;
          let best = Infinity;
          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - this.track.offsetLeft - left);
            if (distance < best) {
              best = distance;
              active = index;
            }
          });
          this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
